import { Row, Col } from 'react-bootstrap'
import {useState, useEffect} from 'react'
import Card  from '../../ui/Card'
import SearchResultContainer from './searchResultContainer'
import { useForm } from 'react-hook-form';
import { Typeahead } from 'react-bootstrap-typeahead'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import Spinner from 'react-bootstrap/Spinner'
import swal from 'sweetalert'
import CodeMaintenanceService from '../../../services/CodeMaintenanceService'
import BaseService from '../../../services/BaseService';
import AddOrganization from './addOrganization'
// import SecurityContainer from '../securityContainer';

const OrganizationMaintenance = () => {
    const [showSearchResult, setShowSearchResult] = useState(false);
    const [openAddOrganizationModal, setOpenAddOrganizationModal] = useState(false);
    const [searchReq, setSearchReq] = useState([]);
    const { handleSubmit} = useForm();
    const [isLoading, setIsLoading] = useState(true);
    const [organization, setOrganization] = useState([]);
    const [orgTypes, setOrgTypes] = useState([]);
    const [orgDivisions, setOrgDivisions] = useState([]);
    const [searchParams, setSearchParams] = useState({
      orgId: '',
      orgTypeCodeId: '',
      orgDivisionCodeId: ''
    })
    
    const handleOrganizationChange = (e, key) => {
      setSearchParams(prevState=>({
        ...searchParams, 
          [key]: e.length > 0 ? e[0][key] : ''
        })
      )
    }
    const handleChange = (e, key) => {
      setSearchParams(prevState=>({
        ...searchParams, 
          [key]:  e.length > 0 ? e[0]['cdiacCodeValueId'] : ''
        })
      )
    }

    const onSubmit = (data) => {
        if(searchParams.orgId === '' && searchParams.orgTypeCodeId === '' && searchParams.orgDivisionCodeId === '') {
          var name = 'Please select at least one search or filter criteria !';
          var content = document.createElement('div');
          content.innerHTML = '<strong>'+ name +'</strong>';
          swal(content);
          return;
        }
        var obj = {
            "orgId": searchParams.orgId,
            "orgTypeCodeId": searchParams.orgTypeCodeId,
            "orgDivisionCodeId": searchParams.orgDivisionCodeId,
        }
        setSearchReq(obj);
        setShowSearchResult(true);
    }

    useEffect(() => {
      async function fetchOrgTypes() {
        var obj = {
            msgId: "null",
            sysId: null,
            opr: "GetLookups",
            hdrStruct: null,
            queryParam: null,
            reqData: { cdiacCode: "ORGT", active: "Y" },
        };
    
        await CodeMaintenanceService.getAllCodes(obj)
        .then((res) => res)
        .then((result) => {
            const filteredList = result.data.responses[0].filter(el => el.activeInd === "Y");
            const orgTypesListNew = [];
            filteredList.forEach((orgType, i)=>{
                let obj = {};
                obj = orgType;
                obj.value = orgType.cdiacCodeValueId;
                obj.label = orgType.cdiacCodeValueDesc;
                orgTypesListNew.push(obj);
            })
            
            setOrgTypes(orgTypesListNew);
            setIsLoading(false);
        })
      }

      async function fetchOrgDivisions() {
        var obj = {
            msgId: "null",
            sysId: null,
            opr: "GetLookups",
            hdrStruct: null,
            queryParam: null,
            reqData: { cdiacCode: "ORGD" },
        };
    
        await CodeMaintenanceService.getAllCodes(obj)
        .then((res) => res)
        .then((result) => {
            setOrgDivisions(result.data.responses[0]);
        })
      }        
      getOrganizations()
      fetchOrgTypes()
      fetchOrgDivisions()
    }, []);

    const getOrganizations = () => {
      //Get Organizations  
      var obj = {
        msgId: null,
        sysId: null,
        opr: "getOrganizationNames",
        hdrStruct: null,
        queryParam: null,
        reqData: { },
      };
  
      BaseService.processRequest(obj)
        .then((res) => res)
        .then((result) => {
          Object.keys(result.data.responses).forEach((key) => {
              setOrganization(result.data.responses[key]);
          });
          setIsLoading(false);
        });
    }

    const handleModalClose = () => {
      setOpenAddOrganizationModal(false)
      getOrganizations()
    }

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <Card>
        <div className="panel panel-default">
          <div className="panel-heading">
            <div className="container">
              <div id="packet_id" className="panel-title" >
                <h1 className="menu-title">Organization Maintenance</h1>
              </div>
            </div>
          </div>
          <div className="panel-body">
            <div className="container">
              <div className="form">
                {isLoading && <Spinner animation="border" variant="primary" />}
                <Row>
                  <Col>
                    <div className="control">
                      <label>Organization Name: </label>
                      <Typeahead
                        placeholder="Choose an Organization"
                        id="organization"
                        labelKey="orgName"
                        onChange={e => handleOrganizationChange(e, "orgId")}
                        inputProps={{ 'data-validations': 'required', name: 'orgName' }}
                        options={organization}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="control">
                      <label>Type: </label>
                      <Typeahead
                        id="orgTypeCodeId"
                        name="orgTypeCodeId"
                        placeholder="Choose Org Type..."
                        labelKey="cdiacCodeValueDesc"
                        onChange={(e) => handleChange(e, 'orgTypeCodeId')}
                        options={orgTypes}
                      />
                    </div>
                  </Col>
                  <Col>
                    <div className="control">
                      <label>Division: </label>
                      <Typeahead
                        placeholder="Choose Org Division"
                        id="orgDivisonCodeId"
                        name="orgDivisonCodeId"
                        labelKey="cdiacCodeValueDesc"
                        onChange={e => handleChange(e, "orgDivisionCodeId")}
                        options={orgDivisions}
                      />
                    </div>
                  </Col>
                </Row>

                <div style={{ overflow: 'auto' }}>
                  <button className="custom-button bg-success text-light rounded" style={{ float: 'left' }} onClick={() => setOpenAddOrganizationModal(true)} >
                    Add New Organization
                  </button>
                  <button style={{ float: 'right' }} className="custom-button" type="Submit" onClick={handleSubmit(onSubmit)}>Search</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {openAddOrganizationModal && <AddOrganization onModalClose={() => handleModalClose()} />}
        {showSearchResult && <SearchResultContainer searchReq={searchReq} />}

      </Card>
    </form>
  )
}

export default OrganizationMaintenance
